<template>
	<div :class="['sky-card',{'topBorder':isCollapse}]" >
		<el-card shadow="never">
			<div slot="header">
				<div v-if="!$slots.header" class="header" @click="toggleActive">
					<div>
						<i
							class="el-icon-arrow-right fontSize"
							:class="{ arrow: true, active: isActive }"
							v-if="isShowCollapseIcon"
						></i>
						<span class="title">{{ title }}</span>
					</div>

					<div @click.stop="e => e">
						<slot name="header-btns"></slot>
					</div>
				</div>
				<slot v-else name="header"></slot>
			</div>
			<el-collapse-transition>
				<div v-show="isActive" class="card-content">
					<slot></slot>
				</div>
			</el-collapse-transition>
		</el-card>
	</div>
</template>
<script>
export default {
	name: 'sky-card',
	props: {
		title: {
			type: String,
			default: '',
		},
		isCollapse: {
			type: Boolean,
			default: true,
		},
		defaultCollapse: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isActive: false,
			isShowCollapseIcon: false,
		};
	},
	created() {
		if (this.isCollapse) {
			this.isShowCollapseIcon = true;
			if (this.defaultCollapse) {
				this.isActive = true;
			}
		} else {
			this.isActive = true;
		}
	},
	methods: {
		toggleActive() {
			if (this.isCollapse) {
				this.isActive = !this.isActive;
			}
		},
	},
};
</script>
<style lang="scss">
.topBorder{
	 border-top: 1px #e8e8e8 solid;
}
.sky-card {
  .el-card {
    border: unset;
    // border-top: 1px #e8e8e8 solid;
  }

  .el-card,
  .el-message {
    border-radius: 0;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    line-height: 54px;
    padding: 0 20px 0 15px;

    .title {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-left: 15px;
    }

    .fontSize {
      font-size: 16px;
    }
  }
  //border-bottom: 1px solid #E8E8E8;
  .el-card__header,
  .el-card__body {
    padding: 0;
    border-bottom: none;
  }
}
</style>
